module.exports = __webpack_public_path__ + "media/images/stop-dont-forget-76bd6f702a0e1c5645223e8be03f23aa.png";